<span [style]="'color: ' + statusColor + '; ' " class="indicator">
  <!-- <button mat-icon-button > -->
  <mat-icon class="midd " [fontSet]="status?.outlined ? 'material-icons-outlined' : '' " mat-list-icon  [matTooltip]="''+statusId">
    {{statusIcon}}
  </mat-icon>
  <!-- </button> -->
  <small class="status-indicator-text" *ngIf="!onlyIcon">{{statusName}} ({{statusId}}) </small>
  <span style="color: black;" class="status-indicator-text" *ngIf="description && status?.description">-
    {{status?.description}} </span>
</span>